// extracted by mini-css-extract-plugin
export var author = "post-card-meta-module--author--JNKqP";
export var authorContainer = "post-card-meta-module--author-container--PF0ed";
export var avatar = "post-card-meta-module--avatar--jfX71";
export var postCardMeta = "post-card-meta-module--post-card-meta--M2Hc1";